import { MenuButton, MenuButtonOption } from 'components/MenuButton/MenuButton';
import { useTranslation } from 'react-i18next';
import { MessageV2DTO } from 'support/types';
import { ActionConfig } from '../types';

type SecondaryActionsProps = {
  actions: Array<ActionConfig>;
  fromDocument: MessageV2DTO;
};

export const SecondaryActions = ({ actions, fromDocument }: SecondaryActionsProps) => {
  const { t } = useTranslation();

  if (!actions.length) {
    return null;
  }

  return (
    <MenuButton
      variant="secondary"
      text={t('transactions:show.actionButtons.moreOptions')}
      testId="ActionButtonOptions"
      size="base"
      analyticsId="transactions:secondary_actions"
    >
      {actions.map((action) => (
        <MenuButtonOption
          data-testid={action.testId}
          key={action.analyticsId}
          onClick={() => {
            action.onClick(fromDocument);
          }}
          analyticsId={action.analyticsId}
          testId={action.testId}
          analyticsProperties={action.analyticsProperties}
        >
          {t(action.label)}
        </MenuButtonOption>
      ))}
    </MenuButton>
  );
};
